<script setup lang="ts">
import ListMenuItem from '../ListMenuItem.vue'

defineProps<{ label?: string }>()

defineOptions({
  name: 'MenuGroupTitle',
})
</script>

<template>
  <ListMenuItem
    class="text-xs-11px-default text-text-subtlest"
    :label="label"
    default-hover-disabled
  >
    <slot />
  </ListMenuItem>
</template>
